import type { MouseEventHandler, ReactNode } from 'react';

import { IconButton, Tooltip } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

import { Z_INDEX } from '@/constants/z-index';

export type WidgetButtonProps = {
  title: string;
  icon: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  id?: string;
  sx?: SxProps<Theme>;
};

const WidgetButton = ({ title, icon, onClick, disabled, id, sx }: WidgetButtonProps) => (
  <Tooltip
    slotProps={{ popper: { sx: { zIndex: Z_INDEX.menu } } }}
    title={title}
  >
    <span style={{ display: 'inline-flex' }}>
      <IconButton
        aria-label={title}
        disabled={disabled}
        id={id}
        sx={[
          {
            width: 30,
            height: 48,
            p: 0,
            minWidth: 30,
            borderRadius: 0,
            backgroundColor: 'secondary.main'
          },
          ...(Array.isArray(sx) ? sx : [sx])
        ]}
        onClick={onClick}
      >
        {icon}
      </IconButton>
    </span>
  </Tooltip>
);

export default WidgetButton;
